"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralRewardItemDtoStatusEnum = exports.ReferralRewardItemDtoRewardTypeEnum = exports.ReferralRewardItemDtoSourceTypeEnum = void 0;
exports.instanceOfReferralRewardItemDto = instanceOfReferralRewardItemDto;
exports.ReferralRewardItemDtoFromJSON = ReferralRewardItemDtoFromJSON;
exports.ReferralRewardItemDtoFromJSONTyped = ReferralRewardItemDtoFromJSONTyped;
exports.ReferralRewardItemDtoToJSON = ReferralRewardItemDtoToJSON;
exports.ReferralRewardItemDtoToJSONTyped = ReferralRewardItemDtoToJSONTyped;
/**
 * @export
 */
exports.ReferralRewardItemDtoSourceTypeEnum = {
    Referrer: 'referrer',
    Referee: 'referee'
};
/**
 * @export
 */
exports.ReferralRewardItemDtoRewardTypeEnum = {
    FreeMonth: 'free_month',
    DiscountCode: 'discount_code',
    Points: 'points'
};
/**
 * @export
 */
exports.ReferralRewardItemDtoStatusEnum = {
    Pending: 'pending',
    Issued: 'issued',
    Failed: 'failed'
};
/**
 * Check if a given object implements the ReferralRewardItemDto interface.
 */
function instanceOfReferralRewardItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('source_type' in value) || value['source_type'] === undefined)
        return false;
    if (!('reward_type' in value) || value['reward_type'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('created_at' in value) || value['created_at'] === undefined)
        return false;
    return true;
}
function ReferralRewardItemDtoFromJSON(json) {
    return ReferralRewardItemDtoFromJSONTyped(json, false);
}
function ReferralRewardItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'source_type': json['source_type'],
        'reward_type': json['reward_type'],
        'status': json['status'],
        'created_at': json['created_at'],
    };
}
function ReferralRewardItemDtoToJSON(json) {
    return ReferralRewardItemDtoToJSONTyped(json, false);
}
function ReferralRewardItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'source_type': value['source_type'],
        'reward_type': value['reward_type'],
        'status': value['status'],
        'created_at': value['created_at'],
    };
}
